import { useEffect } from "react";
import { useLoaderData, useNavigate } from "@remix-run/react";
import { getCookie } from "../utils/TutorConstants";
import { isEmptyOrNull, tutorString, urlString } from "../utils/common-utils";
import { useRoot } from "../context/RootContext";
import { loader as loginLoader, default as Login } from "./login";
import { loader as taskLoader, default as Tasks } from "./home";
import {
  loader as practiceLoader,
  default as Practice,
} from "../routes/practice";
import { loader as learnLoader, default as Learn } from "../routes/learn";
import { loader as homeLoader, default as Home } from "./invalid-school";
import {
  loader as experientialLoader,
  default as Experiential,
} from "../routes/experiential";
import {
  loader as assessmentLoader,
  default as Assessment,
} from "../routes/assessment";
import { loader as doubtLoader, default as DoubtPage } from "../routes/doubt";
import { loader as profileLoader, default as Profile } from "../routes/profile";
import { loader as reviewLoader, default as Review } from "../routes/review";
import {
  loader as onboarding,
  default as OnBoarding,
} from "../routes/onboarding";
import {
  loader as syllabusLoader,
  default as Syllabus,
} from "../routes/syllabus";
import OnboardingScreen from "../components/molecules/onBoarding/onBoarding";

export let loader = async ({ request }) => {
  const url = new URL(request.url);
  let prefix = url.pathname.includes("school") ? "/school/aitutor" : "/aitutor";
  switch (url.pathname) {
    case `${prefix}/login`:
      return loginLoader({ request });
    case `${prefix}/home`:
      return taskLoader({ request });
    case `${prefix}/practice`:
      return practiceLoader({ request });
    case `${prefix}/learn`:
      return learnLoader({ request });
    case `${prefix}/invalid-school`:
      return homeLoader({ request });
    case `${prefix}/experiential`:
      return experientialLoader({ request });
    case `${prefix}/assessment`:
      return assessmentLoader({ request });
    case `${prefix}/doubt`:
      return doubtLoader({ request });
    // case `${prefix}/wall/wall-detailed-page`:
    //   return wallDetailLoader();
    // case `${prefix}/wall/wall-activity`:
    //   return wallActivityLoader();
    // case `${prefix}/wall/school-hub`:
    //   return wallLoader();
    // case `${prefix}/wall/my-space`:
    //   return mySpaceLoader();
    // case `${prefix}/wall/my-class-wall`:
    // return myclassLoader();
    case `${prefix}/profile`:
      return profileLoader({ request });
    case `${prefix}/review`:
      return reviewLoader({ request });
    case `${prefix}/syllabus`:
      return syllabusLoader({ request });
    case `${prefix}/onboarding`:
      return onboarding({ request });
    default:
      return <div>Unknown</div>;
  }
};
export default function CatchAll() {
  const data = useLoaderData();
  const navigate = useNavigate();
  const { isAuthenticated } = useRoot();
  useEffect(() => {
    const schoolId = getCookie("schoolId");
    if (isAuthenticated) {
      if (location.pathname === "/") {
        navigate(
          isEmptyOrNull(schoolId)
            ? `${tutorString}/practice`
            : `${urlString}/home`,
          {
            replace: true,
          }
        );
      }
    } else if (!location?.pathname?.includes("invalid-school")) {
      navigate(`${urlString}/login`, { replace: true });
    }
  }, []);

  switch (data?.type) {
    case "login":
      return <Login />;
    case "tasks":
      return <Tasks />;
    // case "wall":
    //   return <Wall />;
    case "practice":
      return <Practice />;
    case "learn":
      return <Learn />;
    case "home":
      return <Home />;
    case "experiential":
      return <Experiential />;
    case "assessment":
      return <Assessment />;
    case "doubt":
      return <DoubtPage />;
    case "onboarding":
      return <OnBoarding />;
    // case "wall-detailed-page":
    //   return <WallDetailedPage />;
    // case "wall-activity":
    //   return <WallActivity />;
    // case "school-hub":
    //   return <SchoolHub />;
    // case "my-space":
    //   return <MySpace />;
    // case "my-class-wall":
    //   return <MyClassWall />;
    case "profile":
      return <Profile />;
    case "review":
      return <Review />;
    case "syllabus":
      return <Syllabus />;
    default:
      return <div>Unknown</div>;
  }

  return null;
}
